"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOpenQueryParam = exports.removeOpenQueryParam = exports.getValidOpenQueryParam = exports.getOpenQueryParam = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../constants");
const getOpenQueryParam = (param = _constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM) => {
  const url = (0, _presentationUtils.getCurrentUrl)();
  return url.searchParams.get(param);
};
exports.getOpenQueryParam = getOpenQueryParam;
const getValidOpenQueryParam = (param = _constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM) => {
  const queryParam = getOpenQueryParam(param);
  return queryParam === _constants.OPEN_QUERY_PARAM_ONCE || queryParam === _constants.OPEN_QUERY_PARAM_ALWAYS ? queryParam : undefined;
};
exports.getValidOpenQueryParam = getValidOpenQueryParam;
const removeOpenQueryParam = (param = _constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM) => {
  if (getOpenQueryParam(param)) {
    const url = (0, _presentationUtils.getCurrentUrl)();
    url.searchParams.delete(param);
    (0, _presentationUtils.replaceCurrentUrl)(url);
  }
};
exports.removeOpenQueryParam = removeOpenQueryParam;
const setOpenQueryParam = (param = _constants.OPEN_SKIN_DIAGNOSIS_QUERY_PARAM) => {
  const url = (0, _presentationUtils.getCurrentUrl)();
  _constants.REVIEVE_QUERY_PARAMS.forEach(revieveQueryParam => {
    if (revieveQueryParam === param) {
      url.searchParams.set(param, _constants.OPEN_QUERY_PARAM_ONCE);
    } else {
      url.searchParams.delete(revieveQueryParam);
    }
  });
  if (url.searchParams.get(param) !== getOpenQueryParam(param)) {
    (0, _presentationUtils.replaceCurrentUrl)(url);
  }
};
exports.setOpenQueryParam = setOpenQueryParam;